// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type=\"file\"][data-v-069426ad] {\r\n  display: none;\n}\n[dir] .custom-file-upload[data-v-069426ad] {\r\n  padding: 5px 11px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  background-color: #9fc54c;\n}\r\n", ""]);
// Exports
module.exports = exports;
